import useLogout from 'hooks/useLogout';
import { useEffect } from 'react';
import { refreshTokenHandler } from 'services/_https-client';
import { useAuthStore } from 'stores/use-auth-store';

export const useBindRefreshHandlers = () => {
  const { logout } = useLogout();

  useEffect(() => {
    refreshTokenHandler.setCallbacks({
      onRefreshSuccess: async (result) => {
        if (result.team) {
          useAuthStore.getState().setTeam(result.team);
        }

        if (!result.success) {
          return;
        }

        await useAuthStore.getState().setCurrentSession(result.success);
      },
      onRefreshFail: () => logout({ reason: 'refresh-failed' }),
    });

    return () => refreshTokenHandler.setCallbacks(undefined);
  }, [logout]);
};
